/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { lazy } from "react";
import { Loadable } from "components/Loadable";

const Forms = Loadable(lazy(() => import("./index")));
const Attachments = Loadable(lazy(() => import("./attachments/attachments")));

const formsRoutes = [
    {
        path: "forms",
        element: <Forms />,
    },
    {
        path: "forms/attachment",
        element: <Attachments />,
    },
    {
        path: "forms/attachment/:attachmentGuid",
        element: <Attachments />,
    },
    {
        path: "forms/:formType/:formTab/:formGuid",
        element: <Forms />,
    },
    {
        path: "forms/:formType/:formTab/:formGuid/:formSubTab",
        element: <Forms />,
    },
];

export { formsRoutes };
